export default {
    name: "Edit",
    title: "Edit",
    icon: "mdi-square-edit-outline",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
            component: null,
        };
    },
};